import { Atom } from 'AppReact';
import styled from 'styled-components';


const template = styled.div`
    border: 1px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
    width: 60%;;
    border-radius: 50px;
    margin: 20px auto;
`

export default Atom({ type: 'label', dataType: 'string', template })
